export const NEWS_PER_PAGE = 3;
export const ONLY_CYRILLIC_SYMBOLS = /^([а-яА-Я ]{0,500})$/;
export const MIN_STRING_LENGTH = 1;
export const MAX_NAME_LENGTH = 30;
export const MAX_DESCRIPTION_LENGTH = 500;
